module.exports = __webpack_public_path__ + "static/media/green.4340a084.gif";